import { combineReducers } from 'redux'

import basic from './get/basic'
import history from './get/history'

export default combineReducers({
  basic,
  history
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/items/get.js